import { DashboardLayout } from "@/components/dashboard-layout";
import { createFileRoute, redirect } from "@tanstack/react-router";
import { Outlet } from "@tanstack/react-router";

export const Route = createFileRoute("/_dashboard/administrators")({
  component: () => (
    <DashboardLayout>
      <Outlet />
    </DashboardLayout>
  ),
  beforeLoad: ({ location }) => {
    const isExactOrgRoute =
      location.pathname.endsWith(`/administrators`) || location.pathname.endsWith(`/administrators/`);

    if (isExactOrgRoute) {
      throw redirect({
        to: "/administrators/accounts",
      });
    }
    return { title: "Administrators" };
  },
  loader: async () => {
    return {
      crumb: "Administrators",
    };
  },
});
